var _mask, _path, _path2, _path3, _path4, _mask2, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1_63",
    maskUnits: "userSpaceOnUse",
    x: -2.47225,
    y: -1.82843,
    width: 38.1838,
    height: 38.1838,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -2.47225,
    y: -1.82843,
    width: 38.1838,
    height: 38.1838
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1154 19.7437C30.8407 18.0184 30.8407 15.2211 29.1154 13.4958L19.7436 4.12395C18.0183 2.39864 15.221 2.39864 13.4957 4.12395L4.12385 13.4958C2.39854 15.2211 2.39854 18.0184 4.12385 19.7437L13.4957 29.1155C15.221 30.8408 18.0183 30.8408 19.7436 29.1155L29.1154 19.7437ZM16.6196 7.24789L25.9915 16.6197L16.6196 25.9916L7.24779 16.6197L16.6196 7.24789Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1154 19.7437C30.8407 18.0184 30.8407 15.2211 29.1154 13.4958L19.7436 4.12395C18.0183 2.39864 15.221 2.39864 13.4957 4.12395L4.12385 13.4958C2.39854 15.2211 2.39854 18.0184 4.12385 19.7437L13.4957 29.1155C15.221 30.8408 18.0183 30.8408 19.7436 29.1155L29.1154 19.7437ZM16.6196 7.24789L25.9915 16.6197L16.6196 25.9916L7.24779 16.6197L16.6196 7.24789Z",
    fill: "#61C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9915 16.6197L27.4057 18.0339L28.8199 16.6197L27.4057 15.2055L25.9915 16.6197ZM16.6196 7.24789L18.0338 5.83368L16.6196 4.41946L15.2054 5.83368L16.6196 7.24789ZM16.6196 25.9916L15.2054 27.4058L16.6196 28.82L18.0338 27.4058L16.6196 25.9916ZM7.24779 16.6197L5.83358 15.2055L4.41937 16.6197L5.83358 18.0339L7.24779 16.6197ZM27.7012 14.91C28.6455 15.8543 28.6455 17.3852 27.7012 18.3295L30.5296 21.1579C33.036 18.6515 33.036 14.5879 30.5296 12.0816L27.7012 14.91ZM18.3294 5.53816L27.7012 14.91L30.5296 12.0816L21.1578 2.70973L18.3294 5.53816ZM14.9099 5.53816C15.8542 4.5939 17.3851 4.5939 18.3294 5.53816L21.1578 2.70973C18.6514 0.203376 14.5878 0.203376 12.0815 2.70973L14.9099 5.53816ZM5.53806 14.91L14.9099 5.53816L12.0815 2.70973L2.70963 12.0816L5.53806 14.91ZM5.53806 18.3295C4.5938 17.3852 4.5938 15.8543 5.53806 14.91L2.70963 12.0816C0.203277 14.5879 0.203278 18.6515 2.70963 21.1579L5.53806 18.3295ZM14.9099 27.7013L5.53806 18.3295L2.70963 21.1579L12.0815 30.5297L14.9099 27.7013ZM18.3294 27.7013C17.3851 28.6456 15.8542 28.6456 14.9099 27.7013L12.0815 30.5297C14.5878 33.0361 18.6514 33.0361 21.1578 30.5297L18.3294 27.7013ZM27.7012 18.3295L18.3294 27.7013L21.1578 30.5297L30.5296 21.1579L27.7012 18.3295ZM27.4057 15.2055L18.0338 5.83368L15.2054 8.6621L24.5773 18.0339L27.4057 15.2055ZM18.0338 27.4058L27.4057 18.0339L24.5773 15.2055L15.2054 24.5774L18.0338 27.4058ZM5.83358 18.0339L15.2054 27.4058L18.0338 24.5774L8.66201 15.2055L5.83358 18.0339ZM15.2054 5.83368L5.83358 15.2055L8.66201 18.0339L18.0338 8.6621L15.2054 5.83368Z",
    fill: "white",
    mask: "url(#path-1-outside-1_1_63)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565563,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1423 12.7705L24.5112 15.1306L27.6646 12.054L25.2732 9.65039L22.1423 12.7705Z",
    fill: "url(#paint0_linear_1_63)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.273241,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6199 7.24807L18.9887 9.60813L22.1421 6.53158L19.7507 4.12793L16.6199 7.24807Z",
    fill: "url(#paint1_linear_1_63)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-2_1_63",
    maskUnits: "userSpaceOnUse",
    x: 8.57267,
    y: -1.82843,
    width: 38.1838,
    height: 38.1838,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.57267,
    y: -1.82843,
    width: 38.1838,
    height: 38.1838
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1603 13.4958C41.8856 15.2211 41.8856 18.0184 40.1603 19.7437L30.7885 29.1155C29.0632 30.8408 26.2659 30.8408 24.5406 29.1155L15.1688 19.7437C13.4435 18.0184 13.4435 15.2211 15.1688 13.4958L24.5406 4.12395C26.2659 2.39864 29.0632 2.39864 30.7885 4.12395L40.1603 13.4958ZM37.0364 16.6197L27.6646 7.24789L18.2927 16.6197L27.6646 25.9916L37.0364 16.6197Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1603 13.4958C41.8856 15.2211 41.8856 18.0184 40.1603 19.7437L30.7885 29.1155C29.0632 30.8408 26.2659 30.8408 24.5406 29.1155L15.1688 19.7437C13.4435 18.0184 13.4435 15.2211 15.1688 13.4958L24.5406 4.12395C26.2659 2.39864 29.0632 2.39864 30.7885 4.12395L40.1603 13.4958ZM37.0364 16.6197L27.6646 7.24789L18.2927 16.6197L27.6646 25.9916L37.0364 16.6197Z",
    fill: "#2D67C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0364 16.6197L38.4506 18.0339L39.8648 16.6197L38.4506 15.2055L37.0364 16.6197ZM27.6646 7.24789L29.0788 5.83368L27.6646 4.41946L26.2503 5.83368L27.6646 7.24789ZM18.2927 16.6197L16.8785 15.2055L15.4643 16.6197L16.8785 18.0339L18.2927 16.6197ZM27.6646 25.9916L26.2503 27.4058L27.6646 28.82L29.0788 27.4058L27.6646 25.9916ZM38.7461 14.91C39.6904 15.8543 39.6904 17.3852 38.7461 18.3295L41.5745 21.1579C44.0809 18.6515 44.0809 14.5879 41.5745 12.0816L38.7461 14.91ZM38.7461 18.3295L29.3743 27.7013L32.2027 30.5297L41.5745 21.1579L38.7461 18.3295ZM29.3743 27.7013C28.43 28.6456 26.8991 28.6456 25.9548 27.7013L23.1264 30.5297C25.6327 33.0361 29.6964 33.0361 32.2027 30.5297L29.3743 27.7013ZM25.9548 27.7013L16.583 18.3295L13.7546 21.1579L23.1264 30.5297L25.9548 27.7013ZM16.583 18.3295C15.6387 17.3852 15.6387 15.8543 16.583 14.91L13.7546 12.0816C11.2482 14.5879 11.2482 18.6515 13.7546 21.1579L16.583 18.3295ZM16.583 14.91L25.9548 5.53816L23.1264 2.70973L13.7546 12.0816L16.583 14.91ZM25.9548 5.53816C26.8991 4.5939 28.43 4.5939 29.3743 5.53816L32.2027 2.70973C29.6964 0.203376 25.6327 0.203376 23.1264 2.70973L25.9548 5.53816ZM29.3743 5.53816L38.7461 14.91L41.5745 12.0816L32.2027 2.70973L29.3743 5.53816ZM38.4506 15.2055L29.0788 5.83368L26.2503 8.6621L35.6222 18.0339L38.4506 15.2055ZM26.2503 5.83368L16.8785 15.2055L19.7069 18.0339L29.0788 8.6621L26.2503 5.83368ZM16.8785 18.0339L26.2503 27.4058L29.0788 24.5774L19.7069 15.2055L16.8785 18.0339ZM29.0788 27.4058L38.4506 18.0339L35.6222 15.2055L26.2503 24.5774L29.0788 27.4058Z",
    fill: "white",
    mask: "url(#path-5-outside-2_1_63)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5996 25.0341L23.5972 19.0405L26.7417 22.0861L20.7344 28.1482L17.5996 25.0341Z",
    fill: "#61C0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.273241,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7695 21.3443L19.0163 23.5937L22.1321 20.4652L19.827 18.1543L16.7695 21.3443Z",
    fill: "url(#paint2_linear_1_63)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81319,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1443 26.7192L24.6916 29.259L27.6605 25.9914L25.2677 23.5825L22.1443 26.7192Z",
    fill: "url(#paint3_linear_1_63)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_63",
    x1: 22.557,
    y1: 12.4046,
    x2: 24.8835,
    y2: 14.8247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112B54",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_63",
    x1: 21.8003,
    y1: 6.95718,
    x2: 19.4737,
    y2: 4.53709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112B54",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_63",
    x1: 21.8002,
    y1: 20.9625,
    x2: 19.4895,
    y2: 18.6109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112B54",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_63",
    x1: 22.5585,
    y1: 26.4354,
    x2: 24.9703,
    y2: 28.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112B54",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connect-icon.50b1f8b08ed202972a25401b1f0e1e52.svg";
export { ForwardRef as ReactComponent };